
( function( $ ) {

    $( document ).ready( function() {

        // Declare some variables.
        var searchToggle, searchForm, searchField, activeClass;

        body         = document.getElementsByTagName('body')[0];
        searchToggle = document.querySelectorAll( ".search-toggle" );
        searchForm   = document.querySelector( ".site-search" );
        searchClose  = document.querySelector( ".close-search" );
        searchField  = document.getElementById( "big-search" );
        activeClass  = 'search-active';

        for(var i = 0; i < searchToggle.length; i++) {

            // Let's do some searching.
            searchToggle[i].onclick = function( event ) {

                // Don't show a hash or anything silly like that.
                event.preventDefault();

                // Toggle the active class
                body.classList.toggle( activeClass );

                // SetTimeout is used to ensure that focus
                // gets added properly (i.e. doesn't
                // conflict with menu item focus).
                setTimeout( function() {
                    searchField.focus();
                }, 100 );

            };

        }

        // Click to close the search form.
        searchClose.onclick = function( event ) {

            // Don't show a hash or anything silly like
            // that.
            event.preventDefault();

            body.classList.remove( activeClass );

        }

        // Keying ESC to exit search.
        window.onkeydown = function( event ) {

            if ( event.keyCode == 27 ) {

                // Don't show a hash or anything silly like
                // that.
                event.preventDefault();
                body.classList.remove( activeClass );

            }

        };

    })

})( jQuery );